export async function authFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  const { auth } = await import('@/lib/firebase')
  const token = await auth.currentUser?.getIdToken()
  const headers = new Headers(init.headers || {})
  if (token) headers.set('Authorization', `Bearer ${token}`)
  return fetch(input, { ...init, headers })
}


